import React from 'react';
import ScheduleButton from './ScheduleButton';
import ScheduleButtonWithGeneratedContent from './ScheduleButtonWithGeneratedContent';

const ScheduleButtonPicker = ({ agentResource, agendaResource, ...rest }) => {
  if (!agendaResource.attr('generatedContentUpdatedAt')) {
    return <ScheduleButton {...rest} />;
  }

  return <ScheduleButtonWithGeneratedContent resource={agendaResource} {...rest} />;
};

export default ScheduleButtonPicker;
